module.exports = __webpack_public_path__ + "img/41_19.c712d054.png";